import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';

import { RailEmissionService } from '@ruby/core/http/rail-emission/rail-emission.service';
import { IRailEmissionCompany, IRailEmissionReport } from '@ruby/modules/rail-emission/models/rail-emission.interface';
import * as RailEmissionActions from '@ruby/modules/rail-emission/store/actions/rail-emission.actions';
import { IError } from '@ruby/shared/models/request/error.interface';
import { UtilsService } from '@ruby/shared/services/utils/utils.service';

@Injectable()
export class RailEmissionEffects {

  loadRailEmissionFilter$ = createEffect(() => this.actions$.pipe(
    ofType(RailEmissionActions.loadEmissionFilters),
    exhaustMap(() => this.railEmissionService.getEmissionReportFilters().pipe(
      map((response: Array<IRailEmissionCompany>) => RailEmissionActions.loadEmissionFiltersSuccess({ data: response })),
      catchError((error: IError) => of(RailEmissionActions.loadEmissionFiltersFailure({ error })))
    ))
  ));

  loadRailEmissionReport$ = createEffect(() => this.actions$.pipe(
    ofType(RailEmissionActions.loadEmissionReport),
    exhaustMap((action) => this.railEmissionService.getEmissionReport(action.data).pipe(
      map((response: Array<IRailEmissionReport>) => RailEmissionActions.loadEmissionReportSuccess({ data: response })),
      catchError((error: IError) => of(RailEmissionActions.loadEmissionReportFailure({ error })))
    ))
  ));

  auditDownload$ = createEffect(() => this.actions$.pipe(
    ofType(RailEmissionActions.auditDownload),
    exhaustMap((action) => this.railEmissionService.auditDownload(action.data).pipe(
      map(() => RailEmissionActions.auditDownloadSuccess()),
      catchError((error: IError) => of(RailEmissionActions.auditDownloadFailure({ error })))
    ))
  ));

  failureEffect$ = createEffect(() => this.actions$.pipe(
    ofType(RailEmissionActions.loadEmissionReportFailure, RailEmissionActions.loadEmissionFiltersFailure),
    tap(action => this.utilsSvc.showErrorToastr(action.error.title, action.error.message))
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private railEmissionService: RailEmissionService,
    private utilsSvc: UtilsService
  ) {}
}
